import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const createManualPayoutOrder = {
  name: "createManualPayoutOrder" as const,
  input: z.object({
    teamId: zExt.objectId(),
    amount: z.number(),
    chargeType: z.string(),
    returnId: zExt.objectId().optional(),
    orderId: zExt.objectId().optional(),
    internalNote: z.string().optional(),
    payoutId: zExt.objectId().optional(),
  }),
  output: z.object({ payoutOrderId: zExt.objectId(), success: z.boolean() }),
};
